/* eslint-disable */
import axios from 'axios'
import { encode64 } from '@/js/utils/base64'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const recordAnswer = params => new Promise (async (resolve, reject) => {

  let attach = null
  if (typeof(params.value) === 'object') {
    await encode64(params.value)
      .then(response => {
        attach = encodeURIComponent(response)
      })
      .catch(() => {return})
  }


  // let method = params.method === 'post' ? axios.post :
  //                params.method === 'get' ? axios.get : axios.get
  let method = params.method === 'post' ? 'post' :
               params.method === 'get' ? 'get' : 'get'
  let option = params.option ? params.option : 'json'
  let answerid = params.answerid ? sanitize(params.answerid) : null
  let moduleid = params.moduleid ? sanitize(params.moduleid) : null
  let path = params.path ? sanitize(params.path) : null
  let value = params.value ? params.value : null
  let key = sanitize(params.key)

  // method = method === 'post' ? axios.post :
  //          method === 'get' ? axios.get : axios.get
  option = option ? option : 'json'
  answerid = answerid ? encodeURIComponent(answerid) : null
  moduleid = moduleid ? encodeURIComponent(moduleid) : null
  path = path ? encodeURIComponent(path) : null
  value = value ? encodeURIComponent(value) : null
  key = encodeURIComponent(key)

  let uri = option === 'json+file' ? 'options=json+file' :
            option === 'file+delete' ? 'options=file+delete' :
            option === 'delete' ? 'options=delete' :
            option === 'json' ? 'options=json' : 'options=json'
  uri = key && key !== '' &&
        key !== undefined && key !== 'undefined' &&
        key !== null && key !== 'null' ?
        `${uri}&valid=${key}` : uri
  uri = answerid && answerid !== '' &&
        answerid !== undefined && answerid !== 'undefined' &&
        answerid !== null && answerid !== 'null' ?
        `${uri}&answerid=${answerid}` : uri
  uri = moduleid && moduleid !== '' &&
        moduleid !== undefined && moduleid !== 'undefined' &&
        moduleid !== null && moduleid !== 'null' ?
        `${uri}&moduleid=${moduleid}` : uri
  uri = path && path !== '' &&
        path !== undefined && path !== 'undefined' &&
        path !== null && path !== 'null' ?
        `${uri}&path=${path}` : uri
  uri = attach && attach !== '' &&
        attach !== undefined && attach !== 'undefined' &&
        attach !== null && attach !== 'null' ?
        `${uri}&value=${attach}` :
        value && value !== '' &&
        value !== undefined && value !== 'undefined' &&
        value !== null && value !== 'null' ?
        `${uri}&value=${value}` : uri

  // method(process.env.VUE_APP_RECORD_ANSWER_ENDPOINT + uri)
  axios({
    method: 'post',
    url: randomBaseUrl(0, 3) + process.env.VUE_APP_RECORD_ANSWER_ENDPOINT,
    data: uri
  })
    .then(response => {
      // console.log(response)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
